
<template>
  <div id="func-8">
    <FuncionalidadeHeader
      :titulo="funcParams.dashboard.nome"
    />
    <div class="cards">
    <el-row>
    <el-col :xs="23" :sm="13" :md="13" :lg="13" :xl="13">
      <BoxCards @openMap="map = true" @closeMap="map = false"></BoxCards>
    </el-col>
      <el-col :xs="1" :sm="4" :md="4" :lg="11" :xl="11">
        <div>
      </div>
      </el-col>
    </el-row>
      <el-row v-if="!map" style="padding-left: 20px; max-width: 694px;"
      >
        <el-col
          v-for="(item, index) in contatos"
          :key="index"
          :span="11"
        >
        <FuncionalidadeBtn
          :contato="item"
          @click="open(item.id)">
        </FuncionalidadeBtn>
        </el-col>
    </el-row>
  </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import BoxCards from '@/views/8/BoxCards'
import FuncionalidadeBtn from '@/components/FuncionalidadeBtn/FuncionalidadeBtn'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'

export default {
  name: 'Func8Contatos',
  data () {
    return {
      contatos: [],
      superContato: {},
      map: false
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo', 'aplicacao', 'funcParams']),
    ...mapState('SetupApp', ['apiFuncionalidade'])
  },
  methods: {
    async init () {
      let result = await this.apiFuncionalidade.lista({ loading: true })
      this.contatos = result.data
      let index = this.contatos.findIndex(contato => contato.super_contato === 1)
      if (index !== -1) this.contatos.splice(index, 1)
    },
    open (id) {
      this.$router.push({ path: '/8/detalhe', query: { idContato: id } })
    }
  },
  async mounted () {
    this.init()
  },
  components: {
    BoxCards,
    FuncionalidadeBtn,
    FuncionalidadeHeader
  }
}
</script>
<style>
 .cards {
  margin-top: 19px;
 }
</style>
